export default {
  getW9Request(vendorRequest, token) {
    return axios.get(`/api/vendor-portal/w9-request/${vendorRequest}?access_token=${token}`)
  },

  getW9RequestAttachments(vendorRequest, token) {
    return axios.get(`/api/vendor-portal/w9-request/${vendorRequest}/attachments?access_token=${token}`)
  },

  uploadW9(vendorRequest, token, form) {
    return form.post(`/api/vendor-portal/w9-request/${vendorRequest}/attachments?access_token=${token}`)
  },

  deleteW9(vendorRequest, token, attachmentId) {
    return axios.delete(
      `/api/vendor-portal/w9-request/${vendorRequest}/attachments/${attachmentId}?access_token=${token}`,
    )
  },
}
